export default __webpack_public_path__ + "static/media/click&co.9c3f0b23.svg";